import { type FC, type ReactNode } from "react";

import { SecurityNote } from "@/shared/components/ui/security-note";

import { ModalStepLayout } from "./ModalStepLayout";
import { TriageModalSidebar } from "./TriageModalSidebar";

interface TriageModalStepLayoutProps {
  title: string;
  description: string;
  onBack: () => void;
  actionButton?: ReactNode;
  children: ReactNode;
  activeStep?: 1 | 2 | 3 | 4;
  showInvite?: boolean;
  showVaultNotice?: boolean;
}

export const TriageModalStepLayout: FC<TriageModalStepLayoutProps> = ({
  title,
  description,
  onBack,
  actionButton,
  children,
  activeStep = 2,
  showInvite = false,
  showVaultNotice = false,
}) => (
  <ModalStepLayout
    sidebar={<TriageModalSidebar activeStep={activeStep} showInvite={showInvite} />}
    title={title}
    description={description}
    onBack={onBack}
    actionButton={actionButton}
    afterContent={
      showVaultNotice ? (
        <SecurityNote text="Documents are saved to your secure vault, where you can find them anytime" />
      ) : undefined
    }
  >
    {children}
  </ModalStepLayout>
);
